module.exports = __webpack_public_path__ + "static/media/4x6no3-min.886c0552.jpg";